import { render, staticRenderFns } from "./payment_tranzila.vue?vue&type=template&id=72e3fb01&scoped=true"
import script from "./payment_tranzila.vue?vue&type=script&lang=js"
export * from "./payment_tranzila.vue?vue&type=script&lang=js"
import style0 from "./payment_tranzila.vue?vue&type=style&index=0&id=72e3fb01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e3fb01",
  null
  
)

export default component.exports